module.exports = __webpack_public_path__ + "img/login_fail.a8f38640.svg";